import React from "react";

/**
 * Reusable C-ORE brand mark for public onboarding pages.
 * Renders the cropped C-ORE wordmark image (drops the legacy
 * "CORE.AI" text per branding rule — no '.AI' anywhere).
 */
export default function OnboardingLogo() {
  return (
    <div data-testid="onboarding-logo" style={{ textAlign: "center" }}>
      <img
        src="/c-ore-logo.png"
        alt="C-ORE"
        draggable="false"
        style={{
          height: 44,
          width: 160,
          objectFit: "contain",
          display: "inline-block",
        }}
      />
    </div>
  );
}
